import { render, staticRenderFns } from "./ProductChoice.vue?vue&type=template&id=9f6d59cc&"
import script from "./ProductChoice.vue?vue&type=script&lang=js&"
export * from "./ProductChoice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports